import { Form } from 'react-bootstrap';

// コンボボックスコンポーネント
function SelectComponent(props) {
  return (
    <Form.Select
      className={`form-control ${props.className}`}
      value={props.value}
      disabled={props.disabled}
      style={{
        background: props.error ? 'lightpink' : '',
      }}
      onBlur={(e) => (props.onBlur ? props.onBlur(e.target) : null)}
      onChange={(e) => (props.onChange ? props.onChange(e.target) : null)}
    >
      {props.children}
    </Form.Select>
  );
}

export default SelectComponent;
